export const cartProducts = state => {
	let result = [];
  state.cart.added.map(({ _id, quantity, spec, unit = '斤', unit2 }) => {
    const product = state.products.all.find(p => p._id === _id)
    if(product) {
      result.push({
        name: product.name,
				price: product.customerPrice || product.price,
				priceTransfer: product.priceTransfer,
				quantity: unit2 ? quantity * product.priceTransfer : quantity,
				spec,
				unit,
				unit2,
				_id,
				suppliers: product.suppliers,
      });
    }
	})
	result.sort((a,b) => { 
		return a.name.localeCompare(b.name)
	})
  return result;
}

export const productCartNum = state => {
	const map = {};
	
	state.cart.added.map(({_id, quantity, spec}) => {
		if (!map[_id]) {
			map[_id] = quantity
		} else {
			map[_id] += quantity;
		}

		if (spec) {
			map[_id + spec] = quantity
		}
	})
	state.products.all.map(product => {
			if(!map[product._id]){
				map[product._id] = 0;
			}
	})
	return map
}

export const productCartTotalNum = state => {
	let total = 0;
	state.cart.added.map(({quantity}) => {
		total += quantity;
	})

	return total;
}

export const totalPrice = state => {
	let total = 0;
	state.cart.added.map(({ _id, quantity, unit2 }) => {
    	const product = state.products.all.find(p => p._id === _id);
    	product && (total += ((product.unit2 && unit2 && product.priceTransfer) || 1 )*(product.customerPrice || product.price) * quantity);
  	})
    return Math.round(total*100)/100;
}

export const checkoutStatus = state => {
	return state.cart.checkoutStatus
}

export const allAddresses = state => {
	return state.addresses.addresses
}

export const forCustomer = state => {
	return state.products.forCustomer
}



// WEBPACK FOOTER //
// ./src/store/getters.js